import _firebase from 'firebase/compat/app'
import { auth, firestore, functions } from '..'
import { Identifiable, TimestampedManagement } from '../firebase.types'
import { firestoreTimestamp } from '../utility'
import {
  AddressSchema,
  PrerequirementsConfigs,
} from '@onepercentio/rarum-types/_shared'
import { cleanFormObject } from 'utility/fields'

export type UserAddress = Identifiable<TimestampedManagement<AddressSchema>>

export async function addAddress(address: AddressSchema) {
  const created = await firestore
    .collection(`/users/${auth.currentUser!.uid!}/addresses`)
    .add(
      cleanFormObject(
        firestoreTimestamp.createdAt({
          ...address,
          country: address.country ?? 'BR',
        })
      )
    )

  return created.id
}

export async function getAddresses(): Promise<UserAddress[]> {
  return await firestore
    .collection(`/users/${auth.currentUser!.uid!}/addresses`)
    .get({ source: 'server' })
    .then((result) => {
      const addresses = result.docs.map((doc) => {
        const addressSchema = doc.data() as TimestampedManagement<AddressSchema>
        return {
          ...addressSchema,
          country: addressSchema.country ?? 'BR',
          id: doc.id,
        } satisfies UserAddress
      })
      return addresses
    })
}

export async function startKYC(kycMethod: PrerequirementsConfigs['kyc']) {
  switch (kycMethod) {
    case 'brla':
      return await functions.httpsCallable(`accounts-kycUserOnBRLA`)({})
    case 'metamap':
  }
}

export async function resetKYC(kycMethod: PrerequirementsConfigs['kyc']) {
  const methodUpper = kycMethod.toUpperCase() as Uppercase<typeof kycMethod>
  await firestore
    .doc(`/users/${auth.currentUser!.uid}`)
    .update(`kyc.${methodUpper}`, _firebase.firestore.FieldValue.delete())
}
